const config = {
  dev: 'A4LCIVue3lxOR1ua_P2zMs_0B9Evsaypk3iNjsft8m0',
  community: 'nxZu3_PWyO_4w2Q7mX2NxpBmEFp5a_Q2bv8CWfDfOjo'
}

module.exports = config



// WEBPACK FOOTER //
// ./src/config/index.js